import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=3c0474ec&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=ts&"
export * from "./FAQ.vue?vue&type=script&lang=ts&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=3c0474ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0474ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VExpansionPanels})
